/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Features_Plan_WeekInputs */

const en_features_plan_week = /** @type {(inputs: Features_Plan_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`W${i?.n}`)
};

const pl_features_plan_week = /** @type {(inputs: Features_Plan_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`T${i?.n}`)
};

/**
* | output |
* | --- |
* | "W{n}" |
*
* @param {Features_Plan_WeekInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_plan_week = /** @type {((inputs: Features_Plan_WeekInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Plan_WeekInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_plan_week(inputs)
	return en_features_plan_week(inputs)
});